import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, IonModal, ModalController } from '@ionic/angular';
import {
  StateService,
  ToolService,
  RouterService,
  CalendarEvent as cEvent,
  Calendar,
} from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';
import { CalendarEvent, DAYS_OF_WEEK, EventColor } from 'calendar-utils';

@Component({
  selector: 'lib-calendar-event-form',
  templateUrl: './calendar-event-form.component.html',
  styleUrls: ['./calendar-event-form.component.scss'],
  standalone: false,
})
export class CalendarEventFormComponent implements OnInit {
  private translate = inject(TranslateService);

  constructor(
    public state: StateService,
    public tools: ToolService,
    private alertController: AlertController,
    private modalCtrl: ModalController,
    public routerService: RouterService
  ) {}

  subs: Subscription[] = [];
  newEventTypeId: string;
  selectedEvent: cEvent = {};
  isNewEvent: boolean;
  availableCalendars: Calendar[];
  newCalendar: Calendar = {
    id: 'new',
    name: this.translate.instant('calendar.newCalendar'),
    calendarEvents: [],
  };

  newCalendarInputs: any[] = [
    {
      name: 'calendarName',
      type: 'text',
      placeholder: this.translate.instant('calendar.name'),
    },
    {
      name: 'calendarColor',
      type: 'color',
      value: '#ff0000',
    },
  ];
  dbEvents: cEvent[] = [];
  events: CalendarEvent[] = [];

  ngOnInit() {
    this.isNewEvent = this.selectedEvent.id ? false : true;
    this.subs.push(
      this.state.calendars$.subscribe((calendars) => {
        this.availableCalendars = [];
        this.availableCalendars.push(...calendars);
        if (
          this.availableCalendars != null &&
          this.availableCalendars.find((x) => x.id == 'new') == null
        )
          this.availableCalendars?.push(this.newCalendar);
        this.events = [];
        this.dbEvents = [];
        calendars
          .filter((x) => x.active)
          .forEach((calendar) => {
            this.dbEvents.push(...calendar.calendarEvents);
            calendar.calendarEvents.forEach((evt) => {
              this.events.push({
                id: evt.id,
                start: new Date(evt.startDate),
                end: new Date(evt.endDate),
                color: {
                  primary: calendar.borderColorHex,
                  secondary: calendar.backgroundColorHex,
                  secondaryText: calendar.textColorHex,
                },
                title: evt.name,
                allDay: false,
              });
            });
          });
      })
    );
  }

  async evCalendarChange(event: any) {
    if (event.detail.value == 'new') {
      await this.presentCalendarAlert();
    } else {
      this.selectedEvent.calendarId = event.detail.value;
    }
  }

  async presentCalendarAlert() {
    this.newCalendarInputs[1].value = this.getRandomColor();
    const alert = await this.alertController.create({
      header: this.translate.instant('calendar.createNew'),
      inputs: this.newCalendarInputs,
      buttons: [
        {
          text: this.translate.instant('common.cancel'),
          role: 'cancel',
          handler: () => this.handleCancel(),
        },
        {
          text: this.translate.instant('common.create'),
          handler: (data) => this.handleNewCalendar(data),
        },
      ],
    });

    await alert.present();
  }

  addEvent() {
    this.state.createUpdateCalendarEvent(this.selectedEvent);
  }

  updateEvent() {
    let ev = this.events.find((x) => x.id == this.selectedEvent.id);
    ev.title = this.selectedEvent.name;
    ev.start = new Date(this.selectedEvent.startDate);
    ev.end = new Date(this.selectedEvent.endDate);

    this.state.createUpdateCalendarEvent(this.selectedEvent);
  }

  async deleteEvent() {
    this.cancel();
    await this.state.deleteCalendarEvent(this.selectedEvent);
  }

  selectedWorkerChange(e: any) {
    console.log(e);
  }

  cancel() {
    this.modalCtrl.dismiss();
  }

  confirm() {
    if (this.isNewEvent) {
      this.addEvent();
    } else {
      this.updateEvent();
    }

    this.modalCtrl.dismiss();
  }

  handleNewCalendar(data: { calendarName: string; calendarColor: string }) {
    const name = data.calendarName?.trim();
    const color = data.calendarColor;
    if (!name) {
      return false;
    }
    this.state.createCalendar(name, color).subscribe((x) => {
      this.selectedEvent.calendarId = x.id;
    });
    return true;
  }

  handleCancel() {}

  getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  newEventStartDateChanged(evt: string) {
    this.selectedEvent.startDate = evt;
  }
  newEventEndDateChanged(evt: string) {
    this.selectedEvent.endDate = evt;
  }
}
